class AccountSharedUtil {
  isEmailHidden(email) {
    return email.endsWith('@privaterelay.appleid.com');
  }
}
export const accountSharedUtil = new AccountSharedUtil();